import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../_services/auth.service';
import {ContractTypes} from '../../types/contract.types';
import {Subscription} from 'rxjs';
import {buildIdpLink} from '../../modules/share/utils/constants';
import {Router} from "@angular/router";
import {animate, style, transition, trigger} from "@angular/animations";
import {HeaderService} from '../../_services/header.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0}),
        animate('200ms ease-out', style({ opacity: 1})),
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0})),
      ]),
    ]),
  ],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  public langDict = {
    kk: 'Қаз',
    ru: 'Рус',
    // en: 'Eng',
  };
  public langDictMobile = {
    kk: 'Қз',
    ru: 'Ру',
    // en: 'En',
  };

  public timer;
  public minutes;
  public seconds;
  public currentLanguage = this.langDict[this.translate.currentLang];
  public currentLanguageMobile = this.langDictMobile[this.translate.currentLang];
  public languages = [
    { code: 'kk', name: 'Қазақша', title: 'Қазақша'},
    { code: 'ru', name: 'Русский', title: 'Русский'},
    // { code: 'en', name: 'English', title: 'English'},
  ];
  public types = ContractTypes;
  public unreadCount = {
    party: 0,
    initiator: 0,
    personalData: 0,
  };
  interval: any;
  subscriber: Subscription;
  agreementSubscriber: Subscription;
  isNavbarOpen = false;
  headerName = ""

  constructor(
    private router: Router,
    public authService: AuthService,
    public translate: TranslateService,
    private headerService: HeaderService,
    private elementRef: ElementRef<HTMLElement>
  ) { }

  // Шапка фиксированная, а её высота на мобильном и десктопе разная — отдаём
  // реальную высоту в --header-height; от неё .page-flex-my (styles.css)
  // отсчитывает отступ контента, чтобы под шапкой было ровно 16px.
  private headerResizeObserver?: ResizeObserver;

  ngAfterViewInit() {
    const header = this.elementRef.nativeElement.querySelector('header');
    if (!header || typeof ResizeObserver === 'undefined') {
      return;
    }
    const root = document.documentElement;
    this.headerResizeObserver = new ResizeObserver(() => {
      root.style.setProperty('--header-height', `${header.getBoundingClientRect().height}px`);
    });
    this.headerResizeObserver.observe(header);
  }

  ngOnInit() {
    if (this.authService.user) {
      this.getUpdatesCount();
      this.getAgreementUnReadsCount();
    } else {
      this.authService.getProfile();
    }
    // updates count every 5 minutes
    this.interval = setInterval(() => {
      this.getUpdatesCount();
      this.getAgreementUnReadsCount();
    }, 1000 * 60 * 5);

    this.subscriber = this.authService.updateUnreadCountObserve.subscribe(res => {
      if(res) {
        this.getUpdatesCount();
      }
    });
    this.agreementSubscriber = this.authService.updateUnreadAgreementCountObserve.subscribe(res => {
      if (res) {
        this.getAgreementUnReadsCount();
      }
    });

    // Subscribe to header name changes
    this.headerService.headerName$.subscribe(name => {
      this.headerName = name;
    });
  }
  ngOnDestroy() {
    this.headerResizeObserver?.disconnect();
    document.documentElement.style.removeProperty('--header-height');
    clearInterval(this.interval);
    if (this.subscriber) {
      this.subscriber.unsubscribe();
    }
  }
  redirectToIdp() {
    this.authService.logout(false);
    window.location.href = buildIdpLink();
  }
  setLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.authService.setCookie('lang', lang);
    this.currentLanguage = this.langDict[lang];
    this.currentLanguageMobile = this.langDictMobile[lang];
  }
  navigateToIdpLink(){
    window.location.href = buildIdpLink();
  }
  toggleNavbar() {
    this.isNavbarOpen = !this.isNavbarOpen;
    const navbarCollapse = document.getElementById('navbarCollapse');
    const hamburger = document.getElementById('hamburger');
    if (navbarCollapse) {
      if (this.isNavbarOpen) {
        navbarCollapse.classList.add('open');
        hamburger.classList.add('active'); // Add active class
      } else {
        navbarCollapse.classList.remove('open');
        hamburger.classList.remove('active'); // Remove active class
      }
    }
  }
  onBack(){
    if (this.isContractCreate()) {
      // Trigger return functionality for contract create pages
      this.headerService.triggerReturn();
    } else {
      window.mobapp.onBackNavigation();
    }
  }
  closeNavbar(){
    this.isNavbarOpen = false;
    const navbarCollapse = document.getElementById('navbarCollapse');
    const hamburger = document.getElementById('hamburger');
    if (navbarCollapse) {
      if (this.isNavbarOpen) {
        navbarCollapse.classList.add('open');
        hamburger.classList.add('active'); // Add active class
      } else {
        navbarCollapse.classList.remove('open');
        hamburger.classList.remove('active'); // Remove active class
      }
    }
  }

  logout() {
    this.authService.logout(true);
  }

  private getUpdatesCount() {
    // if (this.authService.user) {
    //   this.authService.getUnReadsCount().subscribe(res => {
    //     [this.unreadCount] = res;
    //   });
    // }
  }
  private getAgreementUnReadsCount() {
    if (this.authService.user) {
      this.authService.getAgreementUnReadsCount().subscribe(res => {
        this.unreadCount.personalData = res.result.unread_acceptor_count;
      });
    }
  }

  isLanding() {
    return this.router.url.includes('landing');
  }

  isContractCreate() {
    return this.router.url.includes('/contracts/create/');
  }
}
